import { base } from 'thirdweb/chains'
import { NetworkEnvironment } from '../types'
import environment from '../environment'

export const baseEnvironment: NetworkEnvironment = {
  subgraphUrls: {
    main: `https://gateway.thegraph.com/api/${environment.subgraphApiKey}/subgraphs/id/CJrWGPse4kDakehB5btbEqPKqnzaCf9n1JVUyEftocza`,
    sx1155: `https://gateway.thegraph.com/api/${environment.subgraphApiKey}/subgraphs/id/7e16dRc2Jfmayxu2aRmV1UCxDXdfiLPrZzMvzd7vSgMe`,
    swarm:
      'https://api.studio.thegraph.com/query/60829/swarm-base/version/latest',
  },
  contracts: {
    dotcContractAddress: '0xcfFD07806F6A8fc623d6d61ddC3532BF1D2eB8b9',
    dotcEscrowContractAddress: '0x2B498BaE947C80e358F59a277aDdA90f76344456',
    smtDistributorAddress: '0x743A889aFe3659cfe4f87209Ec5A05fAD5FC6eC1',
  },
  tokens: {
    smt: '0x2974dC646e375e83bd1c0342625b49f288987fA4',
    goldOz: '0x084837A03C1c4B16D554eA0DAC2bBA254b97C292',
    goldKg: '0xa6760BaD8e60225485DD5d806Ec7D493F5D83003',
  },
}

export const baseChainConfig = base
